import { Injectable } from "@angular/core";
import { AppConfig } from "../interfaces/app-config.interface";
import { Config } from "../config";

/**
 * ConfigService now delegates to Config class which loads from backend.json
 * This unifies the configuration system - only backend.json is used
 */
@Injectable({
    providedIn: "root",
})
export class ConfigService {
    get isLoaded(): boolean {
        return Config.isConfigLoaded();
    }

    get api(): string {
        const env = Config.environment;
        if (env.apiDynamic) {
            return `${window.location.protocol}//${window.location.host}`;
        }
        return env.api;
    }

    get tayrona(): string {
        return Config.environment.tayrona;
    }

    get urlWeb(): string {
        return Config.environment.urlWeb || "";
    }

    get urlDashboard(): string {
        return Config.environment.urlDashboard || "";
    }

    get apiOneToOne(): string {
        return Config.environment.apiOneToOne || "";
    }

    get blinkKey(): { default: string; [key: string]: string } {
        return Config.environment.blinkKey;
    }

    get sentry(): AppConfig["sentry"] {
        return Config.environment.sentry;
    }

    get googleAnalyticsKey(): string {
        return Config.environment.googleAnalyticsKey || "";
    }

    get firebaseConfig(): AppConfig["firebaseConfig"] {
        return Config.environment.firebaseConfig;
    }

    get apiDynamic(): boolean {
        return Config.environment.apiDynamic || false;
    }

    getFullConfig(): any {
        return Config.environment;
    }
}

/**
 * No-op initializer - Config is loaded in main.ts before Angular bootstraps
 * Kept for backwards compatibility with APP_INITIALIZER
 */
export function configInitializer(configService: ConfigService): () => Promise<void> {
    return () => Promise.resolve();
}
